// extracted by mini-css-extract-plugin
export default {"container":"x8mcTVq9XBsLRiGF4gjB8Q==","image":"T2x9dpbGp9ULIB52m0332A==","link":"xMq++WK1mnDzxfWqKRa8Yg==","heading":"YGw678ikCZKeqdPe10Q4bw=="};